import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth/auth.service';
import { ProjectService } from '../internal/project-info/serivce/project.service';

/**
 * Route Guard funcional para verificar autenticação
 * Conforme Angular 20 - usando functional guards
 */
export const authGuard = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);


  try {
    const isAuthenticated = await authService.isAuthenticated();
    
    if (!isAuthenticated) {
      router.navigate(['/']);
      return false;
    }

    return true;
  } catch (error) {
    router.navigate(['/']);
    return false;
  }
};

/**
 * Route Guard funcional para verificar se há projeto configurado
 * Usado especificamente para a rota project-info
 */
export const projectGuard = async () => {
  const authService = inject(AuthService);
  const projectService = inject(ProjectService);
  const router = inject(Router);

  try {
    // Primeiro verifica se está autenticado
    const isAuthenticated = await authService.isAuthenticated();
    
    if (!isAuthenticated) {
      router.navigate(['/']);
      return false;
    }

    // Verifica se há projeto configurado usando o ProjectService
    if (!projectService.hasProject()) {
      router.navigate(['/home']);
      return false;
    }

    return true;
  } catch (error) {
    router.navigate(['/']);
    return false;
  }
};
